import template from './home/template';
import approval from './home/approval';
import timetable from './home/timetable';
import hr from './home/hr';
import attendance from './home/attendance';
import vacation from './home/vacation';
import project from './home/project';
import notice from './home/notice';

const home = [
  {
    path: '/dashboard',
    icon: 'icon-web',
    component: () => import('@/page/Dashboard.vue'),
    redirect: '/dashboard/landing',
    meta: {
      name: '대시보드',
      isActive: false,
      isBread: true,
      focus: false,
    },
  },
  {
    path: '/timetable',
    icon: 'icon-schedule',
    component: () => import('@/page/timetable/Index.vue'),
    redirect: '/timetable/overview',
    children: [...timetable],
    meta: {
      name: '타임테이블',
      isActive: false,
      isBread: true,
      focus: false,
    },
  },
  {
    path: '/hr',
    icon: 'icon-supervisor-account',
    component: () => import('@/page/hr/Index.vue'),
    redirect: '/hr/management',
    children: [...hr],
    meta: {
      name: '인사관리',
      isMenu: true,
      isActive: false,
      isBread: true,
      focus: false,
    },
  },
  {
    path: '/attendance',
    icon: 'icon-business-center',
    component: () => import('@/page/attendance/Index.vue'),
    redirect: '/attendance/gatetime',
    children: [...attendance],
    meta: {
      name: '근태관리',
      isMenu: true,
      isActive: false,
      isBread: true,
      focus: false,
    },
  },
  {
    path: '/vacation',
    icon: 'icon-beach-access',
    component: () => import('@/page/vacation/Index.vue'),
    redirect: '/vacation/status',
    children: [...vacation],
    meta: {
      name: '연차관리',
      isMenu: true,
      isActive: false,
      isBread: true,
      focus: false,
    },
  },
  {
    path: '/approval',
    icon: 'icon-payments',
    component: () => import('@/page/approval/Index.vue'),
    redirect: '/approval/box',
    children: [...approval],
    meta: {
      name: '결재 관리',
      isMenu: true,
      isActive: false,
      isBread: true,
      focus: false,
    },
  },
  {
    path: '/project',
    icon: 'icon-layers',
    component: () => import('@/page/project/Index.vue'),
    redirect: '/project/current',
    children: [...project],
    meta: {
      name: '프로젝트',
      isMenu: false,
      isActive: false,
      isBread: true,
      focus: false,
    },
  },
  {
    path: '/notice',
    icon: 'icon-campaign',
    component: () => import('@/page/notice/Index.vue'),
    redirect: '/notice/current',
    children: [...notice],
    meta: {
      name: '공지사항',
      isMenu: false,
      isActive: false,
      isBread: true,
      focus: false,
    },
  },
];

if (process.env.VUE_APP_ENVIRONMENT === 'local') {
  home.push(...template);
}

export default home;
